import { Injectable } from '@angular/core';
import { CREDIT_PROPOSAL_TEMPLATE } from '../data/credit-proposal-template';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  getCreditProposalTemplate() {
    return structuredClone(
      CREDIT_PROPOSAL_TEMPLATE
    );
  }
}